import React from 'react';
import { MetricGrid } from '../../shared/components/patterns';
import { PageNotice } from '../../shared/components/PageFeedback';

export default function PartyActivityMetrics({ activity }) {
  return <section aria-label="Riepilogo attività" aria-busy={activity.loading}>
    <MetricGrid metrics={activity.metrics} />
    <p className="sr-only">Numero di persone o aziende collegate alle attività. Seleziona una metrica per filtrare l’elenco e aprire le schede collegate.</p>
    {activity.unavailable.length > 0 ? <PageNotice role="alert" className="wt-inline-error">
      Metriche parziali: dati non disponibili per {activity.unavailable.join(', ')}. I conteggi non verificabili sono indicati con —.
    </PageNotice> : null}
  </section>;
}
